/**
 * Format a Date or ISO string to local timezone string: YYYY-MM-DDTHH:mm:ss±HH:mm
 * e.g. 2026-03-19T16:00:00-04:00
 */
export function toLocalISOString(dateInput) {
  const d = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null;
  const offsetMin = -d.getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const hours = Math.floor(Math.abs(offsetMin) / 60);
  const mins = Math.abs(offsetMin) % 60;
  const offsetStr = `${sign}${String(hours).padStart(2, '0')}:${String(
    mins
  ).padStart(2, '0')}`;
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${y}-${mo}-${day}T${h}:${min}:${s}${offsetStr}`;
}

export function calendarEventFactory(event) {
  const startTime =
    event.Start_Time === null || event.Start_Time === undefined
      ? null
      : toLocalISOString(new Date(event.Start_Time));
  const endTimeStr = String(event.End_Time ?? '');
  const hasEndTime = endTimeStr.length >= 1;
  const endTimeRaw = hasEndTime
    ? toLocalISOString(new Date(event.End_Time))
    : '';
  const endTime = endTimeRaw ?? '';
  return {
    id: String(event.id),
    title: event.Name ?? event.title ?? '',
    description: event.Description ?? event.description ?? null,
    startTime: startTime ?? '',
    endTime
  };
}
